export let technologyEN = {
  h1: "Full Physical Environmental Perception \nSensor Model",
  h2: "A new start for the revolution of simulation-based testing",
  h3: "Restore Real Sensor Detection Results",
  h4: "Ensure effectiveness and scenario coverage of automated driving verification and validation",
  carImg: require("@/static/img/coretechnologyCar_en.webp"),
  progressCarVideo: require("@/static/img/coretechnologyVideoWindow_en.mp4"),
  moudleArr: [
    "PlenRay",
    "Full Physical Model",
    "Based on PilotD's ",
    "-physical Ray Technology",
    "Validity approaches ",
    "95%",
    "Replace Real Road Test",
    "Make 10-billion-kilometer automated driving validation feasible.",
  ],
  techVideo: require("@/static/img/coretechnologyCheShi_en.mp4"),
};
export let technologyCN = {
  h1: "全物理级环境感知\n传感器模型",
  h2: "仿真测试变革的全新起点",
  h3: "还原真实传感器探测结果",
  h4: "保证自动驾驶测试有效性和场景覆盖率",
  carImg: require("@/static/img/coretechnologyCar.png"),
  progressCarVideo: require("@/static/img/coretechnologyVideoWindow.mp4"),
  moudleArr: [
    "PlenRay",
    "全物理模型",
    "基于沛岱",
    "物理射线技术",
    "还原率逼近",
    "95%",
    "替代真实道路测试",
    "使百亿公里级智驾验证成为可能",
  ],
  techVideo: require("@/static/img/coretechnologyCheShi.mp4"),
};
